import { Component, OnInit, ChangeDetectionStrategy, Input, ViewEncapsulation } from '@angular/core';
import { ChapterLegendModel } from 'src/app/story/models/chapter-legend.model';
import { ColorUtils } from 'src/app/shared/libraries/colors/colors';

@Component({
  selector: 'app-view-legend',
  templateUrl: './view-legend.component.html',
  styleUrls: ['./view-legend.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewLegendComponent implements OnInit {

  @Input()
  legend: ChapterLegendModel[];

  constructor() { }

  ngOnInit() {
  }

  getComputedColor(colors: [number, number, number]) {
    const hexColor = ColorUtils.rgbToHex(colors, true);
    return hexColor;
  }

}
